import { useMutation } from '@tanstack/react-query';
import { getDeviceBySimCardIdPromise } from 'src/utils/api/get-device-by-sim-card-id';

export const useFindDeviceBySimCardId = () => {
  const { mutateAsync, isPending } = useMutation({
    mutationFn: getDeviceBySimCardIdPromise,
  });

  return {
    findDeviceBySimCardIdAsync: mutateAsync,
    isPending,
  };
};
